export default class Permissao {
    constructor(){
        this.id = null,
        this.nome = '',
        this.nomeOperacao = '',
        this.codigo = null,
        this.principal = false,
        this.ativo = true;
        this.publicada = false;
    }
}